import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { twMerge } from "tailwind-merge";

const TextInput = ({
  id,
  label,
  required,
  placeholder,
  error,
  className,
  showEyeIcon = false,
  isDisabled,
  labelClasses,
  containerClasses,
  autoFocus,
  ...rest
}) => {
  const [show, setShow] = useState(false);
  return (
    <div className={twMerge("mb-4", containerClasses)}>
      {label && (
        <label
          htmlFor={id}
          className={twMerge("block mb-2 text-[0.9rem]", labelClasses)}
        >
          {label} {required && <sup className="text-red-500">*</sup>}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          placeholder={placeholder}
          className={twMerge(
            "w-full p-2 border border-primary/30 focus:border-steelblue focus:text-steelblue rounded-md outline-none text-sm",
            error && "border-red-500 focus:border-red-500",
            isDisabled && "bg-stroke border-stroke",
            className
          )}
          disabled={isDisabled}
          {...rest}
          type={rest?.type ? (show ? "text" : rest?.type) : "text"}
          autoFocus={autoFocus}
        />
        {rest?.type === "password" && showEyeIcon && (
          <button
            onClick={() => setShow(!show)}
            type="button"
            className="absolute inset-y-0 right-0 flex items-center mx-3 pb-4 pt-4 text-gray-600 outline-none"
          >
            {show ? (
              <FaEyeSlash className="text-primary" />
            ) : (
              <FaEye className="text-primary" />
            )}
          </button>
        )}
      </div>
      {error && <small className="text-red-500 text-xs my-1">{error}</small>}
    </div>
  );
};

export default TextInput;
